import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Globals } from '../../ressources/variables/globals';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {

  private serverEndpoint = Globals.serverEndpoint;

  constructor(private http: HttpClient) {}

  getStations(): Promise<any[]> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.get<any>(this.serverEndpoint + '/api/getWinmediaData', { headers })
      .toPromise()
      .then(data => data && data.stations ? data.stations : []);
  }

  getCategories(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.get(this.serverEndpoint + '/api/getCategories', { headers }).toPromise();
  }

  getConfigTable(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.serverEndpoint + '/api/getConfigTable', {}, { headers }).toPromise();
  }

  savePersonalSettings(stations: string, categorie: string, preferNickname: boolean = false): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let body = new HttpParams();
    if (stations !== null && stations !== undefined) {
      body = body.set('stations', stations);
    }
    if (categorie !== null && categorie !== undefined) {
      body = body.set('categorie', categorie);
    }
    body = body.set('prefer_nickname', String(preferNickname));
    return this.http.post(this.serverEndpoint + '/api/savePersonalSettings', body.toString(), { headers }).toPromise();
  }
}
